export const BASE_APP_PATH = '/app';
export const privateAppPath = (url) => `${BASE_APP_PATH}/${url}`;

export const LOGIN_PAGE = '/login';
export const PASSWORD_RESET_PAGE = '/password-reset';
export const SSO_LOGIN_PAGE = '/sso/login';
export const ACTIONS_PAGE = '/actions';
export const privateActionsPath = (url) => `${ACTIONS_PAGE}/${url}`;
